import { render, staticRenderFns } from "./TemplateDownloadDialog.vue?vue&type=template&id=4bf9bb18&"
import script from "./TemplateDownloadDialog.vue?vue&type=script&lang=js&"
export * from "./TemplateDownloadDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports